import lang from "@/views/modules/ExpressionInterests/language/en";

let searchFieldsDef = {
    /* 'eoi_no': {
        label: lang.LBL_EOI_NO,
    }, */
    'eoi_by': {
        label: lang.LBL_EOI_BY,
    },
    'submited_on': {
        label: lang.LBL_ON_DATE,
        type:'daterange'
    },
    'opportunity_title': {
        label: lang.LBL_OPPORTUNITY_TITLE,
        relRef: 'exinterests_opportunitys',
    },
    'eoi_note': {
        label: lang.LBL_NOTE,
    },
    'status': {
        label: lang.LBL_STATUS,
        type: 'checkbox',
        field_infos: 'eoi_status',
    },
};
export default { searchFieldsDef }